module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    attrs: {
      "type": "file",
      "id": "upload",
      "accept": "image/*",
      "value": "上传"
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.curDate))]), _c('br'), _vm._v("\n  " + _vm._s(_vm.beginDate)), _c('br'), _vm._v("\n  " + _vm._s(_vm.endDate)), _c('br'), _vm._v("\n  " + _vm._s(_vm.bb)), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f5a7fc5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/ceshi/tup.vue
// module id = QO0p
// module chunks = 5